'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

var _menuItemActive = require('./menu-item-active.js');

var _searchPreview = require('./search-preview.js');

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleNewJoke = function handleNewJoke(_ref) {
  var self = _ref.currentTarget;

  PubSub.publish(_Constants2.default.newJoke, {});
};

var toggleHeaderNav = function toggleHeaderNav(event) {
  PubSub.publish(_Constants2.default.toggleNavSearch);
};

var closeHeaderNav = function closeHeaderNav(event) {
  PubSub.publish(_Constants2.default.closeNavSearch);
};

var toggleMainMenu = function toggleMainMenu(event) {
  PubSub.publish(_Constants2.default.toggleMenu);
};

var resetMainMenu = function resetMainMenu(event) {
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  !iOS && PubSub.publish(_Constants2.default.resizeMenu);
};

var keyboardCartTrigger = function keyboardCartTrigger(event) {
  PubSub.publish(_Constants2.default.keyboardToggleCart, {
    event: event
  });
};

var setMobileNavigation = function setMobileNavigation(event) {
  PubSub.publish('toggleNavigationMenu', {
    event: event
  });
};

var setUserNavigationType = function setUserNavigationType(event) {
  PubSub.publish('setUserNavigationType', {
    event: event
  });
};

var bindActions = exports.bindActions = function bindActions() {
  $(window).on('resize', resetMainMenu);
  $(document).on('click', '[nav-search-close]', closeHeaderNav);
  $(document).on('keydown', setUserNavigationType);
  $('[data-toggle-mobile-menu]').on('click', toggleMainMenu);
  $('[data-toggle-mobile-menu]').on('keypress', toggleMainMenu);
  $(_Dom2.default.joke).on('click', handleNewJoke);
  $(_Dom2.default.menuItemTrigger).on('click', setMobileNavigation);
  $('[nav-search-toggle]').on('click', toggleHeaderNav);
  $(_Dom2.default.toggleInlineCart).on('keydown', keyboardCartTrigger);
  // set proper menu width
  $(document).on('resize', _handlers.setMenuContainerSize);
  $(document).ready(_handlers.setMenuContainerSize);
  $(_menuItemActive.menuItemActive);
  // reset mobile orientation change
  window.addEventListener('orientationchange', function () {
    PubSub.publish(_Constants2.default.resizeMenu);
  });
  $(".windows-form__input.windows-form__text").on('input', _searchPreview.searchPreview);
};